<div class="content-wrapper container-xxl p-0">
    <div class="content-body">
        <section id="ngx-datatable-shipping">
            <div class="card">
               
                <div
          class="card-title d-flex justify-content-between align-items-center"
        >
          <h4>Facturas asignadas a repartidores</h4>
          <div>
            <!--<button
              class="btn btn-info mr-1"
              rippleEffect
              [routerLink]="['/pages/bash-to-flight']"
            >
              <i data-feather="clipboard" class="mr-0 mr-sm-1"></i
              ><span class="d-none d-sm-inline-block">A Vuelo en Lote </span>
            </button>
            <button
              class="btn btn-primary mr-1"
              rippleEffect
              [routerLink]="['/pages/bill-batch-create']"
            >
              <i data-feather="plus" class="mr-0 mr-sm-1"></i
              ><span class="d-none d-sm-inline-block">Lote de Facturas</span>
            </button>-->
            <button type="button" placement="left"
                class="btn btn-icon btn-info pl-2 text-danger cursor-pointer mr-50"
                height="16"
                rippleEffect                 
                [ngbPopover]="popoverTemplate"
                #popOver="ngbPopover"
placement="left-top"
[autoClose]="'outside'">
                <span class="tracking-logo">
                    <i class="fa fa-bars fa-lg" style="color:#ffff"></i> 
                    Filtrar                   
                  </span></button>  
                  
            <button
            [disabled]="assignments.length == 0"
              class="btn btn-primary"
              rippleEffect
              (click)="FetchModels()"
            >
              <span class="d-none d-sm-inline-block">Actualizar facturas</span>
            </button>
          </div>
        </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-3 col-12">
                            <div class="d-flex justify-content-between align-items-center m-1">
                                <label class="d-flex align-items-center">Mostrando
                                    <select class="form-control mx-25" [(ngModel)]="basicSelectedOption" (change)="OnSelectionNumberChange()">
                                        <option value="5">5</option>
                                        <option value="10">10</option>
                                        <option value="15">15</option>
                                        <option *ngIf="assignments.length > 15" [value]="assignments.length">Todos</option>
                                    </select>
                                    facturas</label>
                            </div>
                        </div>
                        <div class="col-md-9 col-12 d-flex justify-content-md-end">
                            <div class="d-flex align-items-center justify-content-between pr-1 pb-1 pl-1 pl-md-0 pb-md-0">
                                <div class="pd-2 md-1" *ngIf="filterChips.length > 0">
                                    <a class="pd-2"  tooltipClass="my-tooltip" href="javascript:void(0);" [ngbTooltip]="tooltipTemplate">                                        
                                        Filtros: 
                                    </a>
                                    </div>
                                    <div class="pl-1">
                                        <mat-chip-list #chipList>
                                            <mat-chip *ngFor="let chip of filterChips.slice(0, 2);" [selectable]="selectable"
                                                     [removable]="removable" (removed)="Remove(chip)">
                                                     <span class="chip-header">{{chip.name}}</span><span class="chip-text pl-1 text-nowrap">{{chip.text}}</span>
                                              <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                                            </mat-chip>                                        
                                          </mat-chip-list>
                                    </div>   
                                <div [formGroup]="searchFrm" class="d-flex align-items-center pl-2"><label>Buscar</label><input #searchInput type="search"
                                        placeholder="Factura o  Repartidor" class="form-control ml-25"                                           
                                        formControlName="text"                                  
                                         />
                                        <button class="btn btn-success align-items-center ml-1" type="button" (click)="export()" [disabled]="!assignments?.length">
                                            <em class="fa fa-print"></em>
                                          </button>
                                        </div>
                            </div>
                        </div>
                    </div>
                    <ngx-datatable #table ngx-resize-watcher [count]="totalRecords" [externalPaging]="true"                    
                    [rows]="assignments" [rowHeight]="58" class="bootstrap core-bootstrap"
                        [columnMode]="ColumnMode.force" [headerHeight]="40" [footerHeight]="50" [scrollbarH]="true"
                        [limit]="basicSelectedOption"
                        [messages]="{emptyMessage: 'No hay información para mostrar', totalMessage: 'Total de facturas'}">
                        <ngx-datatable-column [width]="155" name="Código" prop="billId">
                            <ng-template let-billId="value" ngx-datatable-cell-template>
                                <a (click)="DownloadPdf(billId)" target="_self" placement="right"
                  ngbTooltip="Descargar pdf">
                    {{ GetCodeById(billId) }}</a
                  ><br>
                  {{GetServiceCodeById(billId)}}
                                <!--<a [href]="GetURLById(id)" target="_blank">
                                    {{GetCodeById(id)}}</a>-->
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column [width]="148" name="Repartidor" prop="dealerName">
                            <ng-template let-dealer="value" ngx-datatable-cell-template>
                                <div placement="left" [ngbTooltip]="'Dealer Name'">
                                    <span class="d-inline-block text-truncate" style="max-width: 150px;">
                                        {{dealer | limitText}}</span>
                                </div>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column [width]="148" name="Origen" prop="billSenderModel">
                            <ng-template let-sender="value" ngx-datatable-cell-template>
                                <div placement="left" [ngbTooltip]="'Telefono: ' + sender?.Phone">
                                    <span class="d-inline-block text-truncate" style="max-width: 150px;">
                                        {{sender?.Name | limitText}}</span>
                                </div>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column [width]="148" name="Destino" prop="billCustomerModel">
                            <ng-template let-customer="value" ngx-datatable-cell-template>
                                <div placement="left" [ngbTooltip]="'Telefono: ' + customer?.Phone">
                                    <span class="d-inline-block text-truncate" style="max-width: 150px;">
                                        {{customer?.Name | limitText}}</span>
                                </div>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column [width]="70" name="Peso" prop="billPounds">
                            <ng-template let-pounds="value" ngx-datatable-cell-template>
                                <span>{{pounds | number: '1.2-2'}}</span>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column [width]="90" name="Total" prop="billTotal">
                            <ng-template let-total="value" ngx-datatable-cell-template>
                                <span>{{total | currency}}</span>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column [width]="100" name="Estado" prop="billStateCatalogName">
                            <ng-template let-state="value" ngx-datatable-cell-template>
                                <div class="badge badge-primary">
                                    {{state | limitText}}
                                </div>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="Acciones" [width]="200" [sortable]="false" prop="idCode">
                            <ng-template ngx-datatable-cell-template let-assigmentId="value">
                                <button class="btn btn-outline-light text-primary dropbtn" [ngbPopover]="popoverTemplate" #popOver="ngbPopover"
                                    data-container="body" placement="left-top" [autoClose]="'outside'" type="button" id="defaultDropdown"
                                    aria-expanded="false">
                                    <em class="fa fa-bars"></em>
                                </button>
                                <ng-template #popoverTemplate style="overflow: visible;">
                                    <div>
                                        <button type="button" ngbTooltip="Desasignar" placement="left"
                                            class="btn btn-icon btn-outline-danger text-danger cursor-pointer mr-50" rippleEffect
                                            (click)="Unassign(assigmentId.id)">
                                            <span [data-feather]="'delete'"></span></button>
                                        <button *ngIf="!assigmentId.isInDispatch" type="button" ngbTooltip="Reasignar Repartidor" placement="left"
                                            class="btn btn-icon btn-outline-info text-info cursor-pointer mr-50" rippleEffect
                                            (click)="OpenAssignToDealer(assigmentId.id)">
                                            <span [data-feather]="'edit'"></span></button>
                                    </div>
                                </ng-template></ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-footer *ngIf="true">
                            <ng-template
                              ngx-datatable-footer-template
                              let-rowCount="totalRecords"
                              let-pageSize="basicSelectedOption"
                              let-selectedCount="selectedCount"
                              let-curPage="curPage"
                              let-offset="offset"
                            >
                            <div class="d-flex justify-content-between w-100">
                              <div class="col-7 col-lg-7 col-sm-7" style="padding: 5px 10px">                
                                <div>Total facturas: {{ totalRecords }} | Total libras: {{ totalPounds | number :'1.2-2' }} | Total cobrado: {{ totalPaid | currency}}</div>
                              </div>
                              <div class="col-5 col-lg-5 col-sm-5 align-items-center align-self-end text-right text-nowrap">
                                  
                            <datatable-pager [pagerLeftArrowIcon]="'datatable-icon-left'" [pagerRightArrowIcon]="'datatable-icon-right'"
                                [pagerPreviousIcon]="'datatable-icon-prev'" [pagerNextIcon]="'datatable-icon-skip'" [page]="page"
                                [visiblePagesCount]="currentVisible" [size]="basicSelectedOption" [count]="totalRecords"
                                (change)="onPageChange($event)">
                            </datatable-pager>
                                </div>
                            </div>
                            
                            
                              
                              
                            </ng-template>
                          </ngx-datatable-footer>
                    </ngx-datatable>
                </div>
            </div>
            <ng-template #tooltipTemplate>                 
                <div  *ngFor="let chip of filterChips">                        
                    <div class="d-flex">      
                        <h6 class="font-weight-normal">                                                           
                                {{chip.name}}
                                <small class="font-weight-bolder"><b class="pl-1">{{chip.text}}</b> </small>                                                            
                        </h6>
                        
                      </div>
                </div>                    
            
        </ng-template>
        <ng-template #popoverTemplate> 
            <div class="col-md-12 col-12">
                <div class="row pb-1">
                    <div class="col-md-12">
                        <button type="button" class="close" (click)="popOver.close()" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    
                </div>                       
                <app-multiple-filters [father]="fatherComponent" (filterReset)=FilterReset($event) (filterResult)=SetFilter($event)></app-multiple-filters> 
            </div>               
                                             
          </ng-template>
        </section>
    </div>
</div>